<div class="row w-100 vr-header mx-0 justify-content-center  px-md-5 px-3">
    <div class="col-12 col-md-7 vr-header-left mx-0 my-auto mb-0 mb-md-auto order-1">
        <div class="vr-bg-image"></div>
        <div class="vr-header-cotent pt-5 pb-3 pb-md-5">
            <div class="title">
                {{ 'VrCompany.welcomeText' | translate }}
            </div>
            <div class="description mt-2">
                {{ 'VrCompany.Vr_description' | translate }}
            </div>
            <ul class="list">
                <li>
                    {{ 'VrCompany.descBullet1' | translate }}
                </li>
                <li>
                    {{ 'VrCompany.descBullet2' | translate }}
                </li>
            </ul>
            <div class="mt-4">
                <button class="gradient-button" (click)="goToVirtualSteps()">
                    {{ "Get Start Now" | translate }}
                </button>

            </div>
        </div>
    </div>
    <img class="col-12 col-md-5 text-center p-0 order-2 img-fluid mt-4 mt-md-0" src="../../../assets/img/virtual-interview.png" />
</div>



<!-- Virtual Interview Training Circle Steps -->
<section class="vr-steps container-fluid my-5 my-md-0 mt-4">
    <div class="row row-cols-3 gx-0 gx-md-3">
        <div class="col">
            <div class="card">
                <p class="step-number">01</p>
                <div class="circle-card">
                    <span class="circle-step-number">01</span>
                    <p>{{ "vi.steps.step1" | translate }}</p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="card">
                <p class="step-number">02</p>
                <div class="circle-card">
                    <span class="circle-step-number">02</span>
                    <p>{{ "vi.steps.step2" | translate }}</p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="card">
                <p class="step-number">03</p>
                <div class="circle-card">
                    <span class="circle-step-number">03</span>
                    <p>{{ "vi.steps.step3" | translate }}</p>
                </div>
            </div>
        </div>
    </div>
</section>